import { GET_PROMOTIONS } from '../../../axios/appiendPoints';
import { axiosInstanceNext } from '../../../axios/axios';

export const getPromotions = (restaurantId) => {
  return axiosInstanceNext.get(`${GET_PROMOTIONS}?restaurant_id=${restaurantId}&active=1`);
};
